import Enumerable from "linq";
import { FormatReference } from ".";

export class FormatSet {
  constructor(
    public id: string,
    public name: string,
    public formats: FormatReference[],
    public recordId: number) {
  }

  clone() {
    return new FormatSet(
      this.id,
      this.name,
      this.formats
        ? Enumerable.from(this.formats)
          .select(f => f.clone())
          .toArray()
        : null,
      this.recordId,
    );
  }
}
